package org.moxultimate.topwithmox.pages

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.data.add
import com.varabyte.kobweb.core.init.InitRoute
import com.varabyte.kobweb.core.init.InitRouteContext
import com.varabyte.kobweb.core.layout.Layout
import org.moxultimate.topwithmox.components.layouts.PageLayoutData
import org.moxultimate.topwithmox.components.restricted.RestrictedPage
import org.moxultimate.topwithmox.core.toggle.FeatureToggle
import org.moxultimate.topwithmox.wallpapercrud.main.WallpaperCRUDPage

@InitRoute
fun initWallpaperCRUDRoute(ctx: InitRouteContext) {
    ctx.data.add(PageLayoutData("Wallpaper CRUD"))
}

/**
 * WallpaperCRUDRoute
 * Renders [WallpaperCRUDPage] when [FeatureToggle.WALLPAPER_CRUD_TOGGLE] is enabled,
 * otherwise shows [RestrictedPage].
 */
@Page
@Layout(".components.layouts.PageLayout")
@Composable
fun WallpaperCRUDRoute() {
    if (FeatureToggle.WALLPAPER_CRUD_TOGGLE) WallpaperCRUDPage() else RestrictedPage()
}
